import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ParentLocationUrlValue {
  private url$ = new BehaviorSubject<string>("");

  constructor() {}

  /** @return The parent window URL if the application runs in an iframe or the current window URL */
  get value() {
    return this.url$.getValue();
  }

  set(value: string) {
    this.url$.next(value);
  }
}
